import { useState, useEffect } from "react"
import { api } from "../../../../lib/api"
import { useSelectedAccount } from "../../../../contexts/AccountContext"
import type { Category } from "../../../../types/analytics"

type Props = {
  selectedAccountId: number
  value: number | null
  onChange: (id: number | null) => void
}

const CategorySelector = ({ selectedAccountId, value, onChange }: Props) => {
  const { organizations } = useSelectedAccount()
  const orgId = organizations.find(o => o.accounts.some(a => a.id === selectedAccountId))?.id
  const [categories, setCategories]               = useState<Category[]>([])
  const [showNewInput, setShowNewInput]           = useState(false)
  const [newCategoryName, setNewCategoryName]     = useState("")
  const [creating, setCreating]                   = useState(false)

  useEffect(() => {
    if (!selectedAccountId) return
    const params = orgId != null ? `?organization_id=${orgId}` : ""
    api.get<Category[]>(`/instagram_accounts/${selectedAccountId}/categories${params}`)
      .then(setCategories)
      .catch(() => {})
  }, [selectedAccountId, orgId])

  const handleCreate = async () => {
    if (!newCategoryName.trim()) return
    setCreating(true)
    try {
      const orgParam = orgId != null ? `?organization_id=${orgId}` : ""
      const created = await api.post<Category>(
        `/instagram_accounts/${selectedAccountId}/categories${orgParam}`,
        { category: { name: newCategoryName.trim() } }
      )
      setCategories(prev => [...prev, created])
      onChange(created.id)
      setShowNewInput(false)
      setNewCategoryName("")
    } catch {
    } finally {
      setCreating(false)
    }
  }

  return (
    <div className="form-group">
      <label className="form-group__label">カテゴリ（任意）</label>
      {!showNewInput ? (
        <select
          className="form-input"
          value={value ?? ""}
          onChange={e => {
            if (e.target.value === "__new__") {
              setShowNewInput(true)
              onChange(null)
            } else {
              onChange(e.target.value ? Number(e.target.value) : null)
            }
          }}
        >
          <option value="">カテゴリなし</option>
          {categories.map(c => (
            <option key={c.id} value={c.id}>{c.name}</option>
          ))}
          <option value="__new__">+ 新規作成...</option>
        </select>
      ) : (
        <div style={{ display: "flex", gap: 8 }}>
          <input
            type="text"
            className="form-input"
            value={newCategoryName}
            onChange={e => setNewCategoryName(e.target.value)}
            placeholder="新しいカテゴリ名"
            autoFocus
          />
          <button
            type="button"
            className="ps-btn ps-btn--primary"
            onClick={handleCreate}
            disabled={creating || !newCategoryName.trim()}
          >
            {creating ? "..." : "作成"}
          </button>
          <button
            type="button"
            className="ps-btn"
            onClick={() => { setShowNewInput(false); setNewCategoryName("") }}
          >
            キャンセル
          </button>
        </div>
      )}
    </div>
  )
}

export default CategorySelector
